import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';

import {fetchAppInit} from '@/api/internal/system/system-api';
import {useBaseLayerStore} from '@/store/baseLayerStore';
import {useKrasLayerStore} from '@/store/krasLayerStore';
import {useLayerManagerStore} from '@/store/layerManagerStore';
import {useMapServiceStore} from '@/store/mapServiceStore';
import {useWeatherLocationStore} from '@/store/weatherLocationStore';

export const useAppInitializer = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        console.info('App initializing...');
        const {mapServices, weatherLocations, krasLayerInfos, clusterLayerScale} = await fetchAppInit();

        const mapServiceStore = useMapServiceStore.getState();
        mapServiceStore.setServices(mapServices);

        const weatherLocationStore = useWeatherLocationStore.getState();
        weatherLocationStore.setWeatherLocations(weatherLocations);

        const baseLayers = mapServices.filter((s) => s.mapTypeCode === '1002' || s.mapTypeCode === '1003');
        useBaseLayerStore.getState().setBaseLayers(baseLayers);

        const krasLayerStore = useKrasLayerStore.getState();
        krasLayerStore.setKrasLayers(krasLayerInfos);

        const layerManagerStore = useLayerManagerStore.getState();
        layerManagerStore.setClusterLayerScale(clusterLayerScale);

        setIsReady(true);
      } catch (error) {
        toast.error('앱 초기화 중 문제가 발생했습니다.');
        console.error('App 초기화 실패:', error);
      }
    };

    init();
  }, []);

  return isReady;
};
